import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetConfigCategoriesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ConfigCategoryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ConfigCategoryDocumentSortInput> | Types.ConfigCategoryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetConfigCategoriesQuery = { __typename?: 'Query', configCategories?: { __typename?: 'ConfigCategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ConfigCategoryDocument', configCategoryId: string, code: string, name: string, defaultSizeUomCode: string, resolvedEachesPerUnit?: number | null, sizeUomCodes: Array<string>, containerConfigIds: Array<string>, status: Types.ConfigCategoryStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ConfigCategorySummaryFragment = { __typename?: 'ConfigCategoryDocument', configCategoryId: string, code: string, name: string, defaultSizeUomCode: string, resolvedEachesPerUnit?: number | null, sizeUomCodes: Array<string>, containerConfigIds: Array<string>, status: Types.ConfigCategoryStatus };

export const ConfigCategorySummaryFragmentDoc = new TypedDocumentString(`
    fragment ConfigCategorySummary on ConfigCategoryDocument {
  configCategoryId
  code
  name
  defaultSizeUomCode
  resolvedEachesPerUnit
  sizeUomCodes
  containerConfigIds
  status
}
    `, {"fragmentName":"ConfigCategorySummary"});
export const GetConfigCategoriesDocument = new TypedDocumentString(`
    query GetConfigCategories($where: ConfigCategoryDocumentFilterInput, $order: [ConfigCategoryDocumentSortInput!], $first: Int, $after: String) {
  configCategories(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...ConfigCategorySummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ConfigCategorySummary on ConfigCategoryDocument {
  configCategoryId
  code
  name
  defaultSizeUomCode
  resolvedEachesPerUnit
  sizeUomCodes
  containerConfigIds
  status
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetConfigCategories: build.query<GetConfigCategoriesQuery, GetConfigCategoriesQueryVariables | void>({
      query: (variables) => ({ document: GetConfigCategoriesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetConfigCategoriesQuery, useLazyGetConfigCategoriesQuery } = injectedRtkApi;
